export const PinnacleMappingQueryKeys = {
  all: () => ["pinnacle-mapping"],
  itemTypes: () => [...PinnacleMappingQueryKeys.all(), "item-types"],
  suggestions: (itemTypeId: string) => [...PinnacleMappingQueryKeys.all(), "suggestions", itemTypeId],
  usage: (customerId: string) => [...PinnacleMappingQueryKeys.all(), "usage", customerId],
  affectedParts: (customerId: string, itemTypeId: string) => [
    ...PinnacleMappingQueryKeys.all(),
    "affected-parts",
    customerId,
    itemTypeId,
  ],
};
